import React from 'react';
import { Collapse, Button, Row, Col } from 'antd';
import DocsGroup from '../../components/docs/DocsGroup'
import { DocCardView } from '../containers'
import { executeGetDocs } from '../../simbix/executer'

const Panel = Collapse.Panel;

const LoadingComponent = () => (
    <div style={{ textAlign: 'center', marginTop: 12, height: 32, lineHeight: '32px',}}>
        <Button shape="circle" loading />
    </div>
  );

const TitleDoc = (doc) => {
    return doc.NName + ((doc.Date)?' от '+doc.Date:"") +((doc.Number)?' №'+doc.Number:"")+ ' '+doc.Title
}

class DocsList extends React.Component {
  
    constructor(props, context) {
        super(props, context)
        const {filter, header} = props
        this.state = {
            loading: false, 			//Флаг загрузки 
            filter: filter,
            header: (header)? header:"Файлы и документы",
            selectedGroup: undefined,   //Выбранная группа
            docs: []
        }
        this.selectGroup = this.selectGroup.bind(this);
    }
    
    componentWillMount() { 
        this.loadDocs(undefined);
    }

    //Описание группы документов (по которому формируется условие отбора)
    loadDocs (group) {
        this.setState({loading: true})
        if (!group) {
            this.setState({loading: false, docs: []});
            return Promise.resolve()
        }
        const condition = "ParId="+group.NodId;
        return executeGetDocs({condition})
            .then ((response) =>{
                const {docs} = response
                this.setState({loading: false, docs: docs.data, selectedGroup: group});
                return Promise.resolve(response)
            })
            .catch(e => { 
                return Promise.reject(e);
            });
    }

    selectGroup(group) {
        console.log("selectGroup", group);
        if (group) this.loadDocs(group)
    }

    render() {
        const { loading, filter, header, docs, selectedGroup } = this.state
        const headerItemList = (selectedGroup)?selectedGroup.NName: "";
        console.log(this)
            return (
                <div>
                    <Row>
                        <Col span={6}><DocsGroup filter={filter} header={header} onSelectFolder={this.selectGroup}/></Col>
                        <Col span={18}>
{(loading? <LoadingComponent />:
<table className="big-rubber-blk">
    <tbody>
        <tr className="top-row">
            <td className="top-left-corner"></td>
            <td className="top-middle"></td>
            <td className="top-right-corner"></td>
        </tr>
        <tr className="middle-row">
            <td className="middle-left-col"></td>
            <td className="blk-body">
            <h1>{headerItemList}</h1>
<Collapse>
    {docs.map((doc, i) =>  
        <Panel header={TitleDoc(doc)} key={i}>
            <p> <DocCardView id={doc.NodId} /></p>
        </Panel>
    )}
</Collapse>
            </td>
            <td class="middle-right-col"></td>
        </tr>
        <tr className="bottom-row">
            <td className="bottom-left-corner"></td>
            <td className="bottom-middle"></td>
            <td className="bottom-right-corner"></td>
        </tr>
    </tbody>
</table>
)}
                        
                        </Col>
                    </Row>
                </div>            
        )
    }
}

export default DocsList;